import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const setQuestionImportant = async ({ questionId, important }) => {
  const data = await request.put(
    `/Question/set_important`,
    { questionId, important },
    'Не удалось изменить важность вопроса',
    'Error'
  );

  return data;
};

const useQuestionImportantMutation = (options) => {
  return useMutation(
    ({ questionId, important }) =>
      setQuestionImportant({ questionId, important }),
    options
  );
};

export default useQuestionImportantMutation;
